import * as React from 'react';
import { useState } from 'react';
import { BookmarkService } from '../../services/bookmarkService';

export default function BookmarkListItem({ bookmark }) {
    const bookmarkService = new BookmarkService();
    const bookmarkId = bookmark.id;

    const [isSelected, setIsSelected] = useState(true);

    const unSelectPinnedBookmark = () => {
        bookmarkService.unSelectPinnedBookmark(
            bookmarkId,
            () => {
                setIsSelected(false);
            },
            () => {}
        );
    };

    return (
        <div className={`hero-menucontent__list-item ${isSelected ? '' : 'hidden'}`}>

            <a href="" className="hero-menucontent__list-action-link hero-menucontent__list-action-link-move" onClick={(e) => { e.preventDefault() }} title="Dra och släpp för att ändra ordning på genvägarna" tabIndex="-1"></a>

            <a href={`${bookmark.pageUrl}#${bookmark.markupId || ''}`} className="hero-menucontent__list-item-link">
                <div className={`top`}>
                    <div>
                        {bookmark.documentMetaType ? (
                        <span className="tag">{bookmark.documentMetaType}</span>
                        ) : ""}
                    </div>
                    <button className={`hero-menucontent__list-action-toggle`}
                        onClick={(e) => {
                            e.preventDefault();
                            unSelectPinnedBookmark();
                        }}>Ta bort nål</button>

                </div>
                <div className="bottom">
                    <div className={`notifications__link-item`}>
                        <span className="notification__header-title">{bookmark.title}</span>
                    </div>
                </div>
            </a>
        </div>
    )
}